import { Link, useLocation } from "react-router-dom";
import { useT } from "@/lib/translation";

const Logo = () => {
  const location = useLocation();
  const t = useT();
  const isAnalysis = location.pathname.startsWith("/analysis");

  // Link to different starting points depending on mode
  const destination = isAnalysis
    ? "/analysis/stock-analysis"
    : "/portfolio/dashboard";

  return (
    <Link
      to={destination}
      className="flex h-9 w-full items-center justify-center group"
    >
      <img
        src="/Oitava_Wordmart_noBG.png"
        alt={t("common:logo.alt")}
        className="h-full w-auto object-contain dark:invert transition-all duration-300 translate-y-[2px]"
      />
    </Link>
  );
};

export default Logo;
